export default __webpack_public_path__ + "static/media/blog-img104.e5c68fa6.jpg";